import styled from "styled-components";

const ButtonCircle = styled.button`
  border-radius: 50%;
  border: #ffb81c thin solid;
  background: transparent;
  display: grid;
  width: 1.5em;
  height: 1.5em;
  margin: 0.25em;

  & svg {
    fill: #ffb81c;
    height: 100%;
    width: 100%;
  }

  &:hover {
    background: #ffb81c;
  }

  &:hover svg {
    fill: #000;
  }
`;

export default ButtonCircle;
